import type { AddressCountry, SupportedCountry } from '../types';
import { SupportedCountries } from '../types';

/*
 * Provides a typesafe way to handle all countries when having to
 * seperate content or business logic by country
 */
export interface ByCountryFn {
    <T>(countryRecords: Record<SupportedCountry, T>): T;
}

export function byCountryFactory(countryCode: SupportedCountry): ByCountryFn {
    return <T>(countryRecords: Record<SupportedCountry, T>) => {
        return countryRecords[countryCode];
    };
}

/**
 * A per-country value table. Every market must be listed, so adding a market surfaces every
 * table that needs a value for it. Any other country is optional: these tables hold editorial
 * wording rather than anything the imported place data decides, and a country nobody has
 * worded gets the caller's default rather than blocking the import.
 */
export type CountryRecords<T> = Record<SupportedCountry, T> &
    Partial<Record<AddressCountry, T>>;

export function isSupported(country: string): country is SupportedCountry {
    return (SupportedCountries as readonly string[]).includes(country);
}
